export default __webpack_public_path__ + "static/media/screen4.bee6aab3.png";